import React, { useMemo, useState } from 'react';
import dayjs from 'dayjs';
import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material';
import DaypartsEditor from 'components/DaypartsEditor';
import {getDaypartsError} from 'utils/dayparts';

import useModeSave from 'components/useModeSave';

const fullDay = ['00:00', '23:59'];
const toTimeValue = (time) => dayjs(`2022-02-22 ${time}`);

function getEffectiveDayparts(job, dateKey) {
  return job?.dayparts?.[dateKey] || job?.dayparts?.default || fullDay;
}

const BatchTodayDaypartsDialog = ({jobs, excludedCount=0, onClose, onSaved}) => {
  const {save,dialog}=useModeSave();
  const today = dayjs().tz();
  const todayKey = today.format('YYYYMMDD');
  const effectiveDayparts = useMemo(
    () => jobs.map(job => getEffectiveDayparts(job, todayKey)),
    [jobs, todayKey]
  );
  const initialDayparts = effectiveDayparts[0] || fullDay;
  const [parts, setParts] = useState(() => initialDayparts.map(toTimeValue));
  const [saving, setSaving] = useState(false);

  const mixed = new Set(effectiveDayparts.map(dayparts => dayparts.join('-'))).size > 1;
  const invalid = Boolean(getDaypartsError(parts));

  const handleSubmit = (ev) => {
    ev.preventDefault();
    if (invalid || saving || jobs.length === 0) return;

    setSaving(true);
    const ids = jobs.map(job => job.id).join(',');
    const values=parts.map(time=>time.format('HH:mm'));
    save(`/jobs/batch/today-dayparts?ids=${ids}`, 'PUT', values.length===2?{
      start_time: values[0], end_time: values[1],
    }:{dayparts:values}).then(result=>result?onSaved(result):setSaving(false)).catch(() => setSaving(false));
  };

  return (
    <>
    {dialog}
    <Dialog open={true} onClose={saving ? undefined : onClose}>
      <Box component="form" onSubmit={handleSubmit}>
        <DialogTitle>批量修改当天时段</DialogTitle>
        <DialogContent>
          <Stack spacing={2} sx={{pt: 0.5, minWidth: 360}}>
            <Typography variant="overline" sx={{textTransform: 'none'}}>
              修改日期：{today.format('MM-DD')}
            </Typography>
            <Typography variant="body2">将统一修改 {jobs.length} 个任务今天的投放时段。</Typography>
            {mixed && (
              <Alert severity="warning">
                所选任务当前时段不一致，保存后将统一覆盖为以下当天时段。
              </Alert>
            )}
            {excludedCount > 0 && (
              <Alert severity="info">
                另有 {excludedCount} 个所选任务今天不在投放日期范围内，不会修改。
              </Alert>
            )}
            <DaypartsEditor value={parts} onChange={setParts} labels disabled={saving} />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button type="button" onClick={onClose} disabled={saving}>取消</Button>
          <Button type="submit" disabled={invalid || saving}>
            {saving ? '保存中...' : '保存'}
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
    </>
  );
};

export default BatchTodayDaypartsDialog;
